var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Icon, PageHeading, Section, Dialog } from '../../shared';
import { IllustrationTable } from './illustration-table/illustration-table';
import { services } from '../../../shared';
import { CaseNavigation } from '../case-navigation/case-navigation';
import { APPLICATION } from '../../../config/routes';
import { formStatusName, dialogText } from '../../../shared/types/constants';
import './illustration.scss';
import { useWorkflowStore } from '../../store/workflowStore';
import { useLoader } from '../../../shared/utils';
import { LoaderWrapper } from '../../../shared/utils/loader/loader-wrapper';
export var Illustrations = function (_a) {
    var _b;
    var caseId = _a.caseId, loanPurposeId = _a.loanPurposeId, location = _a.location, pages = _a.pages, steps = _a.steps, formId = _a.formId;
    var _c = useState(), caseDetails = _c[0], setCaseDetails = _c[1];
    var _d = useState(), formPage = _d[0], setFormPage = _d[1];
    var _e = useState(), esisSummary = _e[0], setEsisSummary = _e[1];
    var _f = useState(), pageStep = _f[0], setPageStep = _f[1];
    var _g = useState(false), errorModalVisible = _g[0], setErrorModalVisible = _g[1];
    var _h = useState(false), nextDisabled = _h[0], setnextDisabledPage = _h[1];
    var _j = useState(false), confirmModalVisable = _j[0], setConfirmModalVisable = _j[1];
    var removeWorkflow = useWorkflowStore(function (state) { return state.removeWorkflowStore; });
    var illustrationDocumentsTableSetIsLoading = useLoader({ identifier: 'illustrationDocumentsTable' }).illustrationDocumentsTableSetIsLoading;
    var history = useHistory();
    var fetchCaseDetails = function (caseId, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var caseDetails, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!((_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) !== null && _c !== void 0)) return [3 /*break*/, 1];
                    _a = _c;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, services.getCase(caseId)];
                case 2:
                    _a = (_d.sent()).data;
                    _d.label = 3;
                case 3:
                    caseDetails = _a;
                    setCaseDetails(caseDetails);
                    location = {
                        state: {
                            applicants: caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants,
                            case: caseDetails,
                            loanPurposeId: loanPurposeId,
                        },
                    };
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchEsisSummary = function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var esisDetails, productDetails, redirectUrl, countOfCorrectRecord;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    illustrationDocumentsTableSetIsLoading(true);
                    return [4 /*yield*/, services.getEsisSummary(caseId, formId)];
                case 1:
                    esisDetails = _g.sent();
                    (esisDetails === null || esisDetails === void 0 ? void 0 : esisDetails.isSuccess) && illustrationDocumentsTableSetIsLoading(false);
                    setEsisSummary((_a = esisDetails === null || esisDetails === void 0 ? void 0 : esisDetails.data) !== null && _a !== void 0 ? _a : []);
                    if (!(((_c = (_b = esisDetails === null || esisDetails === void 0 ? void 0 : esisDetails.data) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, services.getAllProductDetails((_e = (_d = esisDetails.data[0]) === null || _d === void 0 ? void 0 : _d.productId) !== null && _e !== void 0 ? _e : 0, loanPurposeId)];
                case 2: return [4 /*yield*/, (_g.sent()).data];
                case 3:
                    productDetails = _g.sent();
                    if (!((_f = productDetails[0]) === null || _f === void 0 ? void 0 : _f.isIllustrationEnabled)) {
                        redirectUrl = "".concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/").concat(formId, "/Fees");
                        window.location.href = redirectUrl;
                        return [2 /*return*/];
                    }
                    countOfCorrectRecord = esisDetails.data.filter(function (o) { return o.documentId > 0 && (o.status == formStatusName.completed || o.status == formStatusName.passed); }).length;
                    if (countOfCorrectRecord <= 0) {
                        setErrorModalVisible(true);
                    }
                    _g.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var submitApplication = function () {
        removeWorkflow();
        history.push("".concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/Complete"));
    };
    useEffect(function () {
        var _a, _b, _c;
        if (steps && formId) {
            var currentStep_1 = steps.findIndex(function (step) { return step.formId == formId; });
            var nextForm_1 = (_b = (_a = steps[currentStep_1 + 1]) === null || _a === void 0 ? void 0 : _a.formId) !== null && _b !== void 0 ? _b : Number(formId);
            if (currentStep_1 < steps.length - 1 && nextForm_1 != 0) {
                services.getPages(nextForm_1).then(function (result) {
                    var _a;
                    if (result) {
                        var row = result.data[0];
                        setPageStep({
                            sectionId: (_a = row.sections[0]) === null || _a === void 0 ? void 0 : _a.id,
                            pageId: row.id,
                            path: "".concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/").concat(nextForm_1, "/").concat(row.id, "/").concat(row.sections[0].id),
                            name: "Start ".concat(steps[currentStep_1 + 1].formType),
                        });
                    }
                });
            }
            else {
                setPageStep({
                    sectionId: 0,
                    pageId: 0,
                    path: "".concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/Complete"),
                    name: 'Complete Full Mortgage Application',
                });
            }
            ((_c = steps[currentStep_1]) === null || _c === void 0 ? void 0 : _c.isComplete) == false ? setnextDisabledPage(true) : setnextDisabledPage(false);
        }
    }, [formId, steps, loanPurposeId, caseId]);
    var hideModal = function () {
        setErrorModalVisible(false);
        setConfirmModalVisable(false);
    };
    var showConfirmModal = function () {
        var _a, _b;
        var currentStep = steps.findIndex(function (step) { return step.formId == formId; });
        var nextForm = (_b = (_a = steps[currentStep + 1]) === null || _a === void 0 ? void 0 : _a.formId) !== null && _b !== void 0 ? _b : Number(formId);
        if (currentStep < steps.length - 1 && nextForm != 0) {
            services.getPages(nextForm).then(function (result) {
                var _a;
                if (result) {
                    var row = result.data[0];
                    setPageStep({
                        sectionId: (_a = row.sections[0]) === null || _a === void 0 ? void 0 : _a.id,
                        pageId: row.id,
                        path: "".concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/").concat(nextForm, "/").concat(row.id, "/").concat(row.sections[0].id),
                        name: "Start ".concat(steps[currentStep + 1].formType),
                    });
                    window.location.href = "".concat(window.location.origin).concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/").concat(nextForm, "/").concat(row.id, "/").concat(row.sections[0].id);
                    return;
                }
            });
        }
        else {
            setConfirmModalVisable(true);
        }
    };
    useEffect(function () {
        if (caseId > 0) {
            //checkIsIllustrationEnabled();
            fetchCaseDetails(caseId, loanPurposeId);
            if (formId > 0) {
                fetchEsisSummary(caseId, formId);
            }
        }
    }, [caseId, loanPurposeId, formId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { modalType: "Info", modalTitle: dialogText.incompleteIllustration.title, message: dialogText.incompleteIllustration.description, show: errorModalVisible, handleClose: hideModal, submit: null, closeButtonText: "Ok" }),
        React.createElement(Dialog, { modalType: "Info", show: confirmModalVisable, handleClose: hideModal, modalTitle: dialogText.submitRecentESIS.title, message: dialogText.submitRecentESIS.description, submit: submitApplication, closeButtonText: "Go back", yesButtonText: "Submit", showYesButton: true }),
        React.createElement(PageHeading, { headingLevel: 2, title: "Illustration", icon: "illustration", mb: 6 }),
        React.createElement(Container, { fullWidth: true },
            React.createElement(Section, { title: "Your illustration documents", mb: 6, headerChildren: React.createElement(LoaderWrapper, { count: 1, height: 45, loaderContainerProps: { style: { width: '100%', textAlign: 'right' } }, loaderComponentProps: { style: { width: '35vw' } }, identifier: "illustrationDocumentsTable" }, (formPage === null || formPage === void 0 ? void 0 : formPage.path.length) > 1 && (React.createElement("div", null,
                    React.createElement(Link, { to: (_b = formPage === null || formPage === void 0 ? void 0 : formPage.path) !== null && _b !== void 0 ? _b : '/', className: "c-btn c-btn--primary" }, esisSummary && esisSummary.length > 0
                        ? 'Update your illustration document'
                        : 'Create an illustration document')))) },
                React.createElement(IllustrationTable, { esisSummary: esisSummary, editPage: formPage === null || formPage === void 0 ? void 0 : formPage.path, caseId: caseId }),
                esisSummary && (React.createElement("div", { className: "c-illustration-footer" },
                    React.createElement("div", { className: "c-illustration-footer-icon" },
                        React.createElement(Icon, { name: "info", size: "large", colour: "primary" })),
                    React.createElement("p", { className: "c-illustration-footer-text" }, "You can update your illustration with new details but make sure you download it first. Once you generate an updated illustration your previous one will be overwritten.")))),
            React.createElement(CaseNavigation, { pages: pages, workflowSteps: steps, location: location, setTargetPage: setFormPage, nextPageStep: pageStep, nextDisabled: nextDisabled, onNextClick: showConfirmModal }))));
};
